export const FETCH_DISCIPLINES_CONTROLS = "FETCH_DISCIPLINES_CONTROLS";

export const INSERT_DISCIPLINE_CONTROL = "INSERT_DISCIPLINE_CONTROL";

export const DELETE_DISCIPLINE_CONTROL = "DELETE_DISCIPLINE_CONTROL";

export const EDIT_DISCIPLINES_CONTROLS = "EDIT_DISCIPLINES_CONTROLS";
